import type { Axis, ScrollingMode } from './useDraggableScrolling'

type ScrollParams = NonNullable<Parameters<typeof useScroll>[1]>

interface Options {
  scrollParams?: Pick<ScrollParams, 'behavior' | 'offset'>
  dragParams?: {
    mode: ScrollingMode
    axises: Axis[]
  }
}

export function useScrollableContainer(
  containerRef: Ref<HTMLElement | null>,
  options?: Options,
) {
  const { isDesktop } = usePlatform()

  /**
   * @TODO
   * В идеале отладить useDraggableScrolling для корректной работы на мобиле
   */
  const getScrollParams = () => ({
    styles: computed(() => ({})),
    ...(isDesktop.value
      ? useDraggableScrolling(
          containerRef,
          options?.dragParams?.axises ?? ['x'],
          options?.dragParams?.mode ?? 'scroll',
          options?.scrollParams,
        )
      : useScroll(containerRef, options?.scrollParams)),
  })
  return getScrollParams
}
